(function () {
  function updateStayAIPrices(variant) {
    if (!variant) return;

    var fmt = function (cents) { return '$' + (cents / 100).toFixed(2); };
    var targetPrice = fmt(variant.price);
    var targetSub = (variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0)
      ? fmt(variant.selling_plan_allocations[0].price)
      : null;

    var apply = function () {
      var oneTimeEl = document.querySelector('[data-stayai-onetime-price]');
      var subscriptionEl = document.querySelector('[data-stayai-subscription-price]');
      if (!oneTimeEl) return;
      if (oneTimeEl.textContent !== targetPrice) oneTimeEl.textContent = targetPrice;
      if (subscriptionEl && targetSub) {
        var expected = '<s class="fullPrice">' + targetPrice + '</s>' + targetSub;
        if (subscriptionEl.innerHTML !== expected) subscriptionEl.innerHTML = expected;
      }
    };

    apply();

    [100, 250, 500, 1000, 2000].forEach(function (delay) {
      setTimeout(apply, delay);
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.closest('variant-radios')) return;
    var variant = window.currentVariant;
    if (variant) updateStayAIPrices(variant);
  });
})();
